export const baseUrl = 'services';

export const ApiService = {
  service: baseUrl,
  serviceByClient: baseUrl
};
